export default {
  duration: 3000,
}
